import React from 'react';

class VibrancyView extends React.Component {
  render() {
    console.error('VibrancyView is not implemented on Android');
    return null;
  }
}

export default VibrancyView;
